import useAsync from 'Hooks/useAsync';
import { getAllNotesForUser } from '../Services/Api/_HumanWritten/NotesService';

/**
 * A customer's notes.
 *
 * `refreshToken` is in the dependency list so a caller that has just written a note can pull the
 * list again by changing it — refetching in place rather than remounting the modal, which would
 * collapse it on mobile and throw away a half-typed note.
 */
export function useUserNotesModal(userId: string, refreshToken?: unknown) {
	const response = useAsync(() => getAllNotesForUser(userId), [userId, refreshToken]);

	return response;
}
